import { PM_PROVIDERS } from 'common/constants/constants';
import { FILTER_TYPES } from 'common/constants/filters';
import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { pmToolSensorIdSelector } from 'state/selectors/sensors-authorizations';

const useFiltersPayloadIssuesKeys = () => {
  const pmSensorId = useSelector(pmToolSensorIdSelector);

  const issuesKeys = useMemo(() => {
    if (!pmSensorId) return {};

    const mapParentToProviderKey = {
      [PM_PROVIDERS.JIRA]: {
        [FILTER_TYPES.ISSUE_PARENT_1]: 'epics',
        [FILTER_TYPES.ISSUE_PARENT_2]: 'initiatives'
      },
      [PM_PROVIDERS.AZURE_BOARDS]: {
        [FILTER_TYPES.ISSUE_PARENT_1]: 'features',
        [FILTER_TYPES.ISSUE_PARENT_2]: 'epics'
      }
    };
    const parentOne =
      mapParentToProviderKey[pmSensorId][FILTER_TYPES.ISSUE_PARENT_1];
    const parentTwo =
      mapParentToProviderKey[pmSensorId][FILTER_TYPES.ISSUE_PARENT_2];

    return { parentOne, parentTwo };
  }, [pmSensorId]);

  return issuesKeys;
};

export default useFiltersPayloadIssuesKeys;
